import React, { FC } from 'react';
import { AIcon } from '../../atoms/AIcon/index';
import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import * as Styled from './MControlTabScroll.styles';
import { MControlTabScrollDirection, type MControlTabScrollProps } from './MControlTabScroll.types';

const COMPONENT_NAME = 'm-web-ui-kit-MControlTabScroll';
const TEST_ID = 'web-ui-kit-MControlTabScroll';

const MControlTabScroll: FC<MControlTabScrollProps> = ({
  direction = MControlTabScrollDirection.Right,
  className,
  'aria-label': providedAriaLabel,
  'aria-labelledby': ariaLabelledBy,
  ...rest
}) => {
  const isLeft = direction === MControlTabScrollDirection.Left;
  const ariaLabel = providedAriaLabel ?? (ariaLabelledBy ? undefined : isLeft ? 'Previous tabs' : 'Next tabs');
  const iconName = isLeft ? 'icon-arrow-left' : 'icon-arrow-right';

  return (
    <Styled.Wrapper
      {...rest}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      $direction={direction}
      type="button"
      aria-label={ariaLabel}
      {...(ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy })}
    >
      <Styled.IconWrapper $direction={direction}>
        <AIcon icon={iconName} size={AIconSize.L} aria-hidden="true" />
      </Styled.IconWrapper>
    </Styled.Wrapper>
  );
};

export { MControlTabScroll, MControlTabScrollDirection, TEST_ID as M_CONTROL_TAB_SCROLL_TEST_ID };
export type { MControlTabScrollProps } from './MControlTabScroll.types';
